import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

// export const deleteTeam = async (teamId: String) => {
//   try {
//     const response = await axiosInstance.delete(`${API_ENDPOINTS.user}/delete`, { data: { teamId: teamId } });
//     return response.data;
//   } catch (error: any) {
//     // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
//     console.log(error, "팀 삭제 실패!");
//   }
// };

// export const restoreTeam = async (teamId: String) => {
//   try {
//     const response = await axiosInstance.post(`${API_ENDPOINTS.user}/restore`, { teamId: teamId });
//     return response.data;
//   } catch (error: any) {
//     // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
//     console.log(error, "팀 삭제 실패!");
//   }
// };

export const createUsers = async (users: any) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.user}/create`, { users });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "계정 생성 실패!");
  }
};

export const activeUser = async (userIds: String[], active: Boolean) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.user}/active`, { userIds, active });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "유저 상태 변경 실패!");
  }
};

export const changeUsersPassword = async (userIds: String[], newPassword: String) => {
  try {
    const response = await axiosInstance.put(`${API_ENDPOINTS.user}/reset/password`, { userIds, newPassword });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "유저 상태 변경 실패!");
  }
};

export const changeUserPosition = async (userId: String, position: String) => {
  try {
    const response = await axiosInstance.put(`${API_ENDPOINTS.user}/position`, { userId, position });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "유저 상태 변경 실패!");
  }
};

export const getUserDetail = async (userId: String) => {
  try {
    const response = await axiosInstance.get(`${API_ENDPOINTS.user}/${userId}/detail`);
    return response.data;
  } catch (error: any) {
    console.log(error, "사용자 상세 정보 조회 실패!");
    throw error;
  }
};